import React from 'react'
import { Link } from 'react-router-dom'

const MyAccountLogged = () => {
  return (
    <ul className='list-unstyled'>
      <li><Link to='/extract'>Extrato</Link></li>
      <li><Link to='/my-orders'>Pedidos</Link></li>
      <li><Link to='/profile'>Informações pessoais</Link></li>
      <li><Link to='/my-address'>Endereço</Link></li>
      <li><Link to='/security-access'>Acesso e segurança</Link></li>
    </ul>
  )
}

export default MyAccountLogged



// WEBPACK FOOTER //
// ./src/App/Footer/MyAccountLogged.js